import { Suspense, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Loading from 'components/Loading';
import useDispatchWithUnwrap from 'hooks/useDispatchWithUnwrap';
import { NotificationType } from 'pages/Notification/NotificationType';
import { NotificationPage } from 'routes/lazyPages';
import RouteChunkFallback from 'routes/RouteChunkFallback';
import { getDeploymentStatus } from 'thunks';

const DeploymentStatusWrapper = () => {
  const [isGetDeploymentStatusInProgress, setIsGetDeploymentStatusInProgress] = useState(true);
  const [isDeployInProgress, setIsDeployInProgress] = useState(false);

  const dispatchWithUnwrap = useDispatchWithUnwrap();

  useEffect(() => {
    const checkDeploymentStatus = async () => {
      try {
        await dispatchWithUnwrap(getDeploymentStatus());
      } catch (error) {
        setIsDeployInProgress(true);
      } finally {
        setIsGetDeploymentStatusInProgress(false);
      }
    };

    checkDeploymentStatus();
  }, [dispatchWithUnwrap]);

  if (isGetDeploymentStatusInProgress) {
    return <Loading />;
  }

  if (!isGetDeploymentStatusInProgress && isDeployInProgress) {
    return (
      <Suspense fallback={<RouteChunkFallback />}>
        <NotificationPage type={NotificationType.UnderMaintenance} />
      </Suspense>
    );
  }

  return <Outlet />;
};

export default DeploymentStatusWrapper;
